import gql from 'graphql-tag';

const query = gql`
  mutation submitAppointmentDetails($params: SessionParams!) {
    submitAppointmentDetails(params: $params)
  }
`;
export default query;
